import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '14px',
        padding: '10px 0',
    },
    inputField: {
        fontSize: '14px',
        paddingTop: '15px',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '12px',
    },
    ellipses1: {
        marginRight: '7px',
        marginLeft: '12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '82px',
        display: 'block',
        ['@media (max-width:600px)']: {
            fontSize: '12px',
        },
    },
    selectView: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '14px',
        paddingTop: '15px',
        '& .MuiSelect-icon': {
            // display: 'none',
            // right: '50%',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inLabel: {
        fontSize: '1.2rem',
        color: '#000000',
    },
    hrClass: {
        width: '100%',
        border: '1px solid #ccc',
        display: 'inline-block',
        fontSize: '2px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },

    plusIcon: {
        display: 'inline-block',
        marginLeft: '5px',
        border: '1px solid black',
        padding: '4px',
        borderRadius: '30px',
        width: '20px !important',
        marginBottom: '-3px',
        height: '20px !important',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    // .btnOrange {
    //     color: #3f51b5 !important;
    //     /* background-color: #3f51b5 !important; */
    //     font-family: Rubik !important;
    //     /* font-weight: 700 !important; */
    //     text-transform: none !important;
    //     padding: 10px 40px !important;
    // }
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
        marginBottom: '10px',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        // padding: '5px 40px',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
        marginBottom: '10px',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        // padding: '5px 40px',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
        marginBottom: '10px',
    },
}));

export default useStyles;
